import { MerchantOutletContext } from '@/@type/router/booking';
import BookingSeoHead from '@/components/public/booking/BookingSeoHead';
import BookingPrivacyPolicy from '@/components/public/booking/Privacy/Privacy';
import { Container } from '@mui/material';
import { useOutletContext } from 'react-router-dom';

const OrderBuddyBookingPrivacyPolicy = (): JSX.Element => {
    const { merchant } = useOutletContext<MerchantOutletContext>();

    return (
        <>
            <BookingSeoHead
                merchant={merchant}
                pageTitleSuffix="Booking Privacy"
                pageDescriptionSuffix="Read the booking privacy policy."
                shouldIndex={false}
            />
            <Container
                sx={{
                    width: { xs: '100vw', sm: '70vw' },
                    display: 'flex',
                    flexDirection: 'column',
                    justifyContent: 'center',
                    alignItems: 'center'
                }}
            >
                <BookingPrivacyPolicy />
            </Container>
        </>
    );
};
export default OrderBuddyBookingPrivacyPolicy;
